// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomMenu_wrapper__LtdLR","active":"BottomMenu_active__tYNAe","list":"BottomMenu_list__jlBhg","link":"BottomMenu_link__Cxvs-"};